import type { CSSProperties } from 'react';

/** Semantic background styles for content display areas */
export const CONTENT_BOX: Record<string, CSSProperties> = {
  confirmed: {
    background: '#f6ffed',
    border: '1px solid #b7eb8f',
    padding: 16,
    borderRadius: 8,
    whiteSpace: 'pre-wrap',
    minHeight: 100,
  },
  draft: {
    background: '#fafafa',
    padding: 12,
    borderRadius: 8,
    whiteSpace: 'pre-wrap',
    minHeight: 40,
    color: '#666',
    fontSize: 13,
  },
  photoRequest: {
    background: '#e6f7ff',
    border: '1px solid #91d5ff',
    padding: 16,
    borderRadius: 8,
    whiteSpace: 'pre-wrap',
    minHeight: 60,
  },
  notes: {
    background: '#fafafa',
    padding: 16,
    borderRadius: 8,
    whiteSpace: 'pre-wrap',
    minHeight: 40,
    color: '#666',
  },
} as const;

/** 8px-based spacing scale */
export const SPACING = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
} as const;

/** Urgency border styles for KPI cards */
export const URGENCY_BORDER: Record<string, CSSProperties> = {
  danger: { borderLeft: '3px solid #cf1322' },
  warning: { borderLeft: '3px solid #fa8c16' },
  none: {},
} as const;

/** Shared transition */
export const TRANSITION = 'all 0.2s ease';

/** Number of date-group CSS classes (date-group-0 .. date-group-7) */
const DATE_GROUP_COUNT = 8;

/**
 * Build a map from scheduled_date → CSS class name (date-group-N).
 * Each unique date gets a class; adjacent dates cycle through colors.
 */
export const buildDateGroupMap = (
  rows: ReadonlyArray<{ scheduled_date: string }>,
): Record<string, string> => {
  const map: Record<string, string> = {};
  let colorIndex = 0;

  for (const row of rows) {
    const date = row.scheduled_date;
    if (map[date] !== undefined) continue;
    map[date] = `date-group-${colorIndex % DATE_GROUP_COUNT}`;
    colorIndex++;
  }

  return map;
};
